import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import activatedPromocodeImg from './img/activatedPromocode.png';

import * as S from './styled';

import { SpinLoader } from './spinLoader';
import { useT } from '@hooks';
import { appStore } from '@store';

export interface Props {
	promocode?: string;
	buttonText?: string;
	doOnClick?: () => void;
}

export const PromocodeAnimated: FC<Props> = observer(props => {
	const { promocode = 'VERV2023', buttonText = 'Activate' } = props;
	const [isActivated, setActivated] = useState(false);
	const [isClicked, setClicked] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const { promocodeActivated } = appStore.paymentStore;
	const { T } = useT();

	const doOnClick = () => {
		if (!isClicked) {
			setClicked(true);
			setLoading(true);
			setTimeout(() => {
				setLoading(false);
				setActivated(true);
			}, 1000);
		}
	};

	useEffect(() => {
		if (isClicked) {
			appStore.paymentStore.setPromocodeActivated(true);
		}
	}, [isActivated]);

	return (
		<S.Container>
			<S.PromocodeWrapper onClick={doOnClick}>
				<S.TextWrapper>
					<S.Title>
						{promocodeActivated ? T('discount_activated') : T('discount_no_activated')}
					</S.Title>
					{!promocodeActivated && (
						<>
							{T('use_with_button')}
							<S.Promocode>{promocode}</S.Promocode>
						</>
					)}
				</S.TextWrapper>
				<>
					{!isClicked && !promocodeActivated && <S.Button>{buttonText}</S.Button>}
					{isLoading && <SpinLoader />}
					{promocodeActivated && <S.Icon src={activatedPromocodeImg} alt='promo' />}
				</>
			</S.PromocodeWrapper>
		</S.Container>
	);
});
